export function headerMenu() {
  const header_wrapper = document.querySelector('header');
  const header = document.querySelector('.header');  
  const menuButton = document.createElement('button');
  const submenuToggles = document.querySelectorAll('.wp-block-navigation-submenu__toggle');

  menuButton.setAttribute('class', 'menu-button');
  menuButton.setAttribute('aria-label', 'Menu');
  menuButton.setAttribute('aria-expanded', 'false');
  menuButton.setAttribute('aria-controls', 'menu');

  menuButton.addEventListener('click', () => {
    const menu = document.querySelector('nav.main-nav');
    const expanded = menuButton.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
    menuButton.setAttribute('aria-expanded', expanded);
    menu.classList.toggle('open');
  });

  header.prepend(menuButton);

  submenuToggles.forEach(function (toggle) {
      var link = toggle.closest('li').querySelector('a');

      link.addEventListener('click', function (event) {
          var parentLi = this.closest('li');

          if (!parentLi.classList.contains('submenu-open')) {
              event.preventDefault();
              parentLi.classList.add('submenu-open');
          } else {
              parentLi.classList.remove('submenu-open');
          }
      });
  });

  function checkScroll() {
    if (window.scrollY > 0) {
      header_wrapper.classList.add('scrolled');
    } else {
      header_wrapper.classList.remove('scrolled');
    }
  }

  checkScroll();

  window.addEventListener('scroll', checkScroll);
}